<template>
    <form-input :error="error">
        <app-label :for="id" v-if="label">{{ label }}
            <template v-if="isRequired"><span class="asterisk">*</span></template>
        </app-label>
        <iconed-input-field
            :type="type"
            :id="id"
            :placeholder="placeholder"
            :value="value"
            :name="name"
            :is-required="isRequired"
            :is-disabled="isDisabled"
            @input="onInput"
            @focus="onFocus"
        >
            <template>
                <ion-icon class="eye-icon" :name="show ? 'eye-off-outline' : 'eye-outline'" @click="toggle"></ion-icon>
            </template>
        </iconed-input-field>

        <help-block :text="error" />
    </form-input>
</template>

<script>
    export default {
        props: {
            label: String,
            error: {
                type: String,
                default: ''
            },
            placeholder: {
                type: String,
                default: ''
            },
            name: String,
            isRequired: {
                type: Boolean,
                default: false
            },
            isDisabled: {
                type: Boolean,
                default: false
            },
            id: String,
            value: String,
        },
        data() {
            return {
                show: false
            }
        },
        computed: {
            type() {
                return this.show ? 'text' : 'password';
            }
        },
        methods: {
            toggle() {
                this.show = !this.show;
            },
            onInput(value) {
                this.$emit('input', value);
            },
            onFocus(value) {
                this.$emit('focus', value);
            }
        }
    }
</script>

<style scoped lang="scss">
    .eye-icon {
        font-size: 15px;
        cursor: pointer;
        margin-right: 10px;
    }
</style>
